/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-toolbar.title-small-screen[_ngcontent-%COMP%]{height:80px}"];
export { styles as styles };
